import script from "./WizardCurtainRegistCompleteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardCurtainRegistCompleteStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardCurtainRegistCompleteStep.vue?vue&type=style&index=0&id=239e5118&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239e5118"]])

export default __exports__